import { SxProps, Theme } from '@mui/material';

export const textSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-display)',
	fontWeight: '800',
	color: '#2C2C2C',
	letterSpacing: '0px',
};
